import { unref } from "vue";

import DataElement from "../xmlrdb-data/DataElement";

import ElementBase from "./ElementBase";

import AttributeGroup from "./AttributeGroup";
import Attribute from "./Attribute";


export default class XMLRDBElement extends ElementBase {
    /**
   *
   * @param {HTMLElement} node
   * @param {import("./XMLRDBNavigation").default} xmlRDBNavigation
   */
  constructor(node, xmlRDBNavigation) {
    super(node, xmlRDBNavigation);
    /** @type {Array<Attribute>} */
    this.attributes = [];
    /** @type {Array<AttributeGroup>} */
    this.attributeGroups = [];
    /** @type {Array<Attribute>} */
    this.allAttributes = [];

    if (node) {
      node.childNodes.forEach(childnode => {
        if (childnode instanceof Element) {
          if (childnode.tagName === "meta:AttributeGroup") {
            let attributeGroup = new AttributeGroup(childnode, xmlRDBNavigation, this);
            childnode.childNodes.forEach(childChildnode => {
              if (childChildnode instanceof Element) {
                if (childChildnode.tagName === "meta:Attribute") {
                  let attribute = new Attribute(childChildnode, xmlRDBNavigation, attributeGroup);
                  attributeGroup.attributes.push(attribute)
                  this.allAttributes.push(attribute);
                }
              }
            });
            this.attributeGroups.push(attributeGroup);
          }
          else if (childnode.tagName === "meta:Attribute") {
            let attribute = new Attribute(childnode, xmlRDBNavigation, this);
            this.attributes.push(attribute);
            this.allAttributes.push(attribute);
          }
        }
      });
    }
    let parent = this.parent();
    if (parent) {
      parent.children.push(this);
    }
  }

  /**
   * liefert undefined, wenn Attribut nicht gefunden
   */
  attribute(name) {
    return this.allAttributes.find(att => { return att.name() === name; });
  }

  attributeCaseInsensitive(name) {
    let regex = new RegExp(name, "i");
    return this.allAttributes.find(att => { return regex.test(att.name()) });
  }

  visibleAttributes(dataElement) {
    return this.attributes.filter(a => a.isVisible(dataElement));
  }

 
  visibleFormAttributes(dataElement) {
    return this.attributes.filter(a => a.isFormVisible(dataElement));
  }

  name() {
    return this.getNodeAttribute("name");
  }
  
  refId() {
    return this.getNodeAttribute("refId");
  }

  /**
   *     1:n: jedes der Child-Elemente ist genau einem Parent-Element zugeordnet.
   *     n:1: jedes der Parent-Elemente ist genau einem Child-Element zugeordnet.
   *     1:0/1: Das Parent-Element hat ein oder kein Child-Element.
   *     0/1:1: Das Child-Element hat ein oder kein Parent-Element.
   * @returns {('1:n'|'n:1'|'1:0/1'|'0/1:1')}
   */
  cardinality() {
    return this.getNodeAttribute("cardinality");
  }

  id() {
    return this.getNodeAttribute("id");
  }

  isLookup() {
    return this.getNodeAttribute("isLookup") === "true";
  }

  orderby() {
    return this.getNodeAttribute("orderby");
  }

  /**
   * @returns {XMLRDBElement}
   */
  parent() {
    return this.root.getElement(this.getNodeAttribute("parent"));
  }

  path() {
    return this.getNodeAttribute("path");
  }

  reference() {
    return this.getNodeAttribute("reference");
  }

  fkName() {
    return this.getNodeAttribute("fkname");
  }

  inheritanceValue() {
    return this.getNodeAttribute("inheritanceValue");
  }

  writeClass() {
    let tag = this.tagByName("WriteClass");
    if (tag) {
      return tag.value();
    }
    return this.name();
  }


  getPrimaryKeyAttributes() {
    return this.allAttributes.filter(attribute => { return attribute.isIdentifying(); }).sort((a,b) => String.prototype.localeCompare.call(a.name(), b.name()));
  }

  /**
   * @param {Attribute} startFkAttribute
   */
  getForeignKeyAttributes(startFkAttribute) {
    let fkAttributes = [startFkAttribute];
    let pivot = startFkAttribute;
    while (pivot.fkSuccessor()) {
      pivot = this.attribute(pivot.fkSuccessor());
      fkAttributes.push(pivot);
    }
    return fkAttributes;
  }


  newDataElement(parent, isNew = true) {
    let attributes = this.newAttributes();
    return new DataElement({ parent: parent, attributes: attributes, isNew: isNew, metadata: this });
  }

  newAttributes() {
    let attributes = {};
    this.allAttributes.forEach(attrib => {
      attributes[attrib.name()] = null;
    });
    return attributes;
  }

  getLookupLabelFields() {
    return this.allAttributes.filter(a => a.isLookupLabel());
  }

  getLookupLabel(attributes, separator = " ") {
    if (!attributes) {
      return "";
    }
    let res = "";
    let attrs = this.getLookupLabelFields()
    for (let i = 0; i < attrs.length; i++){
      const attr = attrs[i];
      const sep = attr.tagValueByName("LookupLabelConstantAfter") ?? separator;
      const val = unref(attributes[attr.name()]);
      if (val !== null && val !== '') {
        res += attr.formatValue(val);
        if (attrs.length - 1 !== i || attr.tagValueByName("LookupLabelConstantAfter")) 
          res += sep;
      }
    }
    if (res === "") res = "<Ungesetzt>";
    return res;

  }
}